export default {
    updatePublishTemplateDialogOpen(state, payload) {
        state.publishTemplateDialogOpen = payload;
    },

    updateUnpublishTemplateDialogOpen(state, payload) {
        state.unpublishTemplateDialogOpen = payload;
    },

    updatePublishTemplateFormData(state, payload) {
        state.publishTemplateFormData = Object.assign({}, state.publishTemplateFormData, payload);
    },

    updateIsPublishing(state, payload) {
        state.isPublishing = payload;
    },

    updateIsLoading(state, payload) {
        state.isLoading = payload;
    },

    updateStandardOrgIds(state, payload) {
        state.publishTemplateFormData.standard_org_ids = payload.map(item => item.org_id);
    }
}